import { render, staticRenderFns } from "./TreeTypeItem.vue?vue&type=template&id=8acdc382&scoped=true"
import script from "./TreeTypeItem.vue?vue&type=script&lang=js"
export * from "./TreeTypeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acdc382",
  null
  
)

export default component.exports